export const recordsQueryKeys = {
  /** Kept outside the `records` prefix so record invalidations don't re-run checks. */
  writeValidation: (tableId: string, batchKey: string) =>
    ['record-write-validation', tableId, batchKey] as const,
  record: (tableId: string, recordId: string) => ['records', 'detail', tableId, recordId] as const,
  records: (viewId: string, params: { offset: number; limit: number }) =>
    ['records', viewId, params] as const,
  recordsAll: ['records'] as const,
  allRecords: (
    tableId: string,
    columnWindow?: { offset: number; limit: number },
    rowLimit?: number,
    rowOffset?: number,
    /** Serialized config the read sends instead of the stored one (see queryRecords). */
    liveConfig?: string
  ) =>
    columnWindow || rowLimit || rowOffset !== undefined || liveConfig !== undefined
      ? ([
          'records',
          'all',
          tableId,
          {
            columnWindow: columnWindow ?? null,
            rowLimit,
            rowOffset,
            ...(liveConfig !== undefined ? { liveConfig } : {}),
          },
        ] as const)
      : (['records', 'all', tableId] as const),
  recordsInfinite: (
    viewId: string,
    columnWindow?: { offset: number; limit: number },
    rowLimit?: number,
    rowOffset?: number,
    /** Serialized config the read sends instead of the stored one (see queryRecords). */
    liveConfig?: string
  ) =>
    columnWindow || rowLimit || rowOffset !== undefined || liveConfig !== undefined
      ? ([
          'records',
          'infinite',
          viewId,
          {
            columnWindow: columnWindow ?? null,
            rowLimit,
            rowOffset,
            ...(liveConfig !== undefined ? { liveConfig } : {}),
          },
        ] as const)
      : (['records', 'infinite', viewId] as const),
  recordsQuery: (tableId: string, config: Record<string, unknown>) =>
    ['records', 'query', tableId, config] as const,
  /** Prefix for every row-window page of a view (`scope` is the view id). */
  rowWindowRecordsAll: (scope: string) => ['records', 'row-window', scope] as const,
  rowWindowRecords: (
    scope: string,
    columnWindow: { offset: number; limit: number } | undefined,
    rowLimit: number,
    pageIndex: number
  ) =>
    [
      'records',
      'row-window',
      scope,
      { columnWindow: columnWindow ?? null, rowLimit },
      pageIndex,
    ] as const,
  previewRecords: (tableId: string) => ['records', 'preview-records', tableId] as const,
}
